import * as $ from 'jquery';

export function FileDirective(UtilService, ConfirmXmlService, SessionService, companyService) {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, el, ngModel) {
      el.bind('change', function (event) {
        companyService.getCompanies().subscribe((response) => {
          var items = response;
          var selectedCompany = SessionService.getSelectedAccountCompany();
          var company = items.filter((x) => (x.id = selectedCompany.id))[0];

          scope.UtilService = new UtilService(scope);

          if (event.target.files[0]) {
            if (event.target.files[0].name.split('.').pop() !== 'xml') {
              var modalParams = {
                title: 'WARNING_TAX_ID_TITLE',
                body: 'VALID_XML',
              };

              scope.UtilService.warningMsg(modalParams, null, null);

              return;
            } else {
              var file = event.target.files[0];
              var reader = new FileReader();

              reader.onloadend = function (e) {
                // var data = e.target.result;
                var data = e.target;

                ConfirmXmlService.getConfirmXmls().then(function () {
                  var bills = ConfirmXmlService.items;

                  var xmlDoc = $.parseXML(data),
                    $xml = $(xmlDoc),
                    $cedula = $xml.find('Receptor').find('Identificacion').find('Numero'),
                    $cr_key = $xml.find('Clave');

                  var exist = bills.filter((x) => x.cr_key === $cr_key[0].textContent)[0];
                  exist = exist !== undefined ? true : false;

                  var modalParams;

                  if (exist) {
                    modalParams = {
                      title: 'WARNING_TAX_ID_TITLE',
                      body: 'EXIST_XML',
                    };

                    scope.UtilService.warningMsg(modalParams, null, null);

                    return;
                  } else if (!$cedula[0]) {
                    modalParams = {
                      title: 'WARNING_TAX_ID_TITLE',
                      body: 'VALID_XML',
                    };

                    scope.UtilService.warningMsg(modalParams, null, null);

                    return;
                  } else {
                    if ($cedula[0].textContent !== company.tax_id_number) {
                      modalParams = {
                        title: 'WARNING_TAX_ID_TITLE',
                        body: 'WARNING_TAX_ID',
                      };

                      scope.UtilService.warningMsg(modalParams, null, null);
                    } else {
                      ngModel.$setViewValue(file.name + '*********' + data);
                    }
                  }
                });
              };
              reader.readAsBinaryString(file);
            }
          } else {
            ngModel.$setViewValue('NO FILE');
          }
        });
      });
    },
  };
}

FileDirective.$inject = ['UtilService', 'ConfirmXmlService', 'SessionService', 'companyService'];

// link: function (scope, el, attrs, ngModel) {
